import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import PropTypes from "prop-types"
import { withRouter, Link } from "react-router-dom"
import { map } from "lodash"
import * as moment from "moment"
import { isEmpty, size } from "lodash"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import {showSuccessToast} from "helpers/function_helper"
import ReactDrawer from 'react-drawer';
import {
  Button,
  Card,
  CardBody,
  Col,
  CardTitle,
  Container,
  Row,
  Table,
  UncontrolledTooltip,
} from "reactstrap"
import RightDrawer from "../../components/Common/RightDrawer"
//redux
import { useSelector, useDispatch } from "react-redux"
import SweetAlert from "react-bootstrap-sweetalert"
//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"
import useInfiniteScroll from "components/Common/useInfiniteScroll"
import ReportDayPicker from "components/Common/ReportDayPicker"

import { getReport } from "helpers/backend_helper"
import Loader from "components/Common/Loader"

const ProfitReport = props => {
  
  const [isFetching, setIsFetching] = useState(false);
  const [isLoading, setIsLoading] = useState(false)
  const [noMoreData, setNoMoreData] = useState(false)
  const [profitRecords, setProfitRecords] = useState([])
  const [selectedDate, setSelectedDate] = useState({
    startDate : moment(new Date()).format("yyyy-MM-DD"),
    endDate : moment(new Date()).format("yyyy-MM-DD"),
  })

  useEffect(() => {
    getProfitReport({
      startDate : moment(new Date()).format("yyyy-MM-DD"),
      endDate : moment(new Date()).format("yyyy-MM-DD"),
    })
  }, []);

  const getProfitReport = (input) => {
    setIsLoading(true)
    setSelectedDate({
      startDate:input.startDate,
      endDate: input.endDate,
    })
    getReport(input,'profitreport').then(resp => {
      if(resp.length > 0){
        setProfitRecords(resp)
      }
      else if(resp.length == 0){
        setNoMoreData(true)
      }
      setIsFetching(false)
      setIsLoading(false)
    })
  }

  const handleValidDate = date => {
    return moment(new Date(date)).format("DD MMM Y")
  }

  const onConfirmSelectedDates = (dates) => {
    setProfitRecords([])
    setNoMoreData(false)
    getProfitReport({
      startDate : dates.startDate,
      endDate : dates.endDate,
    })
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Profit Report | Flamingo</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title="Reports" breadcrumbItem="Profit" />
          
          <Row>
            <Col xs="12">
              <Card>
                <CardTitle className="mt-0">
                  <Row className="mt-2">
                    <Col xs="4">
                      
                    </Col>
                    <Col xs="4" className="text-center align-middle align-self-center">
                      Profit Report
                    </Col>
                    <Col xs="4" className="text-end d-inline-block pe-3">
                      <ReportDayPicker 
                      onConfirmSelectedDates={onConfirmSelectedDates}
                      loadInProgress={isLoading}
                      /> 
                    </Col>
                  </Row>
                </CardTitle>

                <CardBody style={{minHeight:450}}>
                  <Row>
                    <Col lg="12">
                    <Table className="project-list-table table-sm table-nowrap align-middle ">
                      <tbody>
                        <tr>
                          <td>
                      {map(profitRecords, (account, index) => (
                        <React.Fragment key={index}>
                          <Table className="project-list-table table-sm table-nowrap align-middle pb-0 mb-0 table-outline-bordered-dark">
                          <tbody className="">
                            <tr className="text-center border-bottom">
                              <td colSpan={2}>
                                <span className="me-1 font-size-14">Account : </span><span className="me-1 fw-bold font-size-15">{account.accountName}</span> <span className="mx-2">|</span>
                                <span className="me-1 font-size-14">Date : </span><span className="me-1 fw-bold font-size-15">{handleValidDate(selectedDate.startDate)}</span>
                                {selectedDate.startDate != selectedDate.endDate && 
                                <>
                                  <span className="mx-2">-</span><span className="me-1 fw-bold font-size-15">{handleValidDate(selectedDate.startDate)}</span>
                                </>
                                }
                              </td>
                            </tr>
                            <tr className="text-center p-0 m-0 font-size-14 fw-bold td-underline">
                              <td className="p-0 m-0 ">
                                Income
                              </td>
                              <td className="p-0 m-0">
                                Expense
                              </td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: "top"}}>
                                <Table className="project-list-table table-sm table-nowrap align-middle pb-0 mb-0 table-outline-bordered">
                                  <thead>
                                    <tr className="text-center">
                                      <th scope="col" style={{ width: "100px" }}>
                                        Date
                                      </th>
                                      <th scope="col" style={{ width: "100px" }}>#</th>
                                      <th scope="col" style={{ width: "100px" }}>Amount</th>
                                      <th scope="col" style={{ width: "100px" }}>Profit</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                  {map(account.income, (row, inner) => (
                                    <tr key={inner} className="p-0 text-center">
                                      <td className="p-0 m-0">
                                         {handleValidDate(row.txnDate)}
                                      </td>
                                      <td className="p-0 m-0">
                                        {(row.txnNo)}
                                        {row.description && row.description != '' && <small className="ms-1">({row.description})</small>}
                                      </td>
                                      <td className="p-0 m-0">
                                        {Number(row.debitAmt).toLocaleString('en-IN',{minimumFractionDigits: 2})}
                                      </td>
                                      <td className="p-0 m-0">
                                        {Number(row.currentProfit).toLocaleString('en-IN',{minimumFractionDigits: 2})}
                                      </td>
                                    </tr>
                                  ))}
                                  {account.income.length == 0 && <tr className="text-center"><td colSpan="4">-- No Transactions --</td></tr>}
                                  </tbody>
                                </Table>
                              </td>
                              <td style={{ verticalAlign: "top"}}>
                                <Table className="project-list-table table-sm table-nowrap align-middle pb-0 mb-0 table-outline-bordered">
                                  <thead>
                                    <tr className="text-center">
                                      <th scope="col" style={{ width: "100px" }}>
                                        Date
                                      </th>
                                      <th scope="col" style={{ width: "100px" }}>#</th>
                                      <th scope="col" style={{ width: "100px" }}>Account</th>
                                      <th scope="col" style={{ width: "100px" }}>Amount</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                  {map(account.expense, (row, inner) => (
                                    <tr key={inner} className="p-0 text-center">
                                      <td className="p-0 m-0">
                                         {handleValidDate(row.txnDate)}
                                      </td>
                                      <td className="p-0 m-0">
                                        {(row.txnNo)}
                                      </td>
                                      <td className="p-0 m-0">
                                        {(row.toAccountName)}
                                        {row.description && row.description != '' && <small className="ms-1">({row.description})</small>}
                                      </td>
                                      <td className="p-0 m-0">
                                        {Number(row.creditAmt).toLocaleString('en-IN',{minimumFractionDigits: 2})}
                                      </td>
                                    </tr>
                                  ))}
                                  {account.expense.length == 0 && <tr className="text-center"><td colSpan="4">-- No Transactions --</td></tr>}
                                  </tbody>
                                </Table>
                              </td>
                            </tr>
                            <tr className="text-center border-bottom bg-light">
                              <td colSpan={2}>
                                <span className="me-1 font-size-14">Account : </span><span className="me-1 fw-bold font-size-15">{account.accountName}</span> <span className="mx-2">|</span>
                                <span className="me-1 font-size-14">Income : </span><span className="me-1 fw-bold font-size-15">{Number(account.totalIncome).toLocaleString('en-IN',{minimumFractionDigits: 2})}</span><span className="mx-2">|</span>
                                <span className="me-1 font-size-14">Expense : </span><span className="me-1 fw-bold font-size-15">{Number(account.totalExpense).toLocaleString('en-IN',{minimumFractionDigits: 2})}</span><span className="mx-2">|</span>
                                <span className="me-1 font-size-14">Profit : </span><span className="me-1 fw-bold font-size-15">{Number(account.totalProfit).toLocaleString('en-IN',{minimumFractionDigits: 2})}</span><span className="mx-2">|</span>
                                <span className="me-1 font-size-14">Actual Expense : </span><span className="me-1 fw-bold font-size-15">{Number(account.actualExpense).toLocaleString('en-IN',{minimumFractionDigits: 2})}</span><span className="mx-2">|</span>
                                <span className="me-1 font-size-14">Cash Input : </span><span className="me-1 fw-bold font-size-15">{Number(account.totalCashInput).toLocaleString('en-IN',{minimumFractionDigits: 2})}</span><span className="mx-2">|</span>
                                <span className="me-1 font-size-14">Final Balance : </span><span className="me-1 fw-bold font-size-15">{Number(account.totalIncome + account.totalCashInput - account.actualExpense ).toLocaleString('en-IN',{minimumFractionDigits: 2})}</span>
                              </td>
                            </tr>
                            </tbody>
                          </Table>
                          { /*map(record, (row, inner) => (
                          <tr key={inner} className="p-0">
                            <td className="p-0 m-0">
                              {inner == 0 ? handleValidDate(row.txnDate) : ''}
                            </td>
                            <td className="p-0 m-0">
                            {inner == 0 ? <>
                              <div>{row.txnNo}</div>
                              <div className="text-muted">{row.txnType}</div>
                              </>
                              :null
                              }
                            </td>
                            <td className="p-0 m-0">
                              {row.entryType == 'C' ? <div className="ms-3">{row.description}</div> : <div className="ms-0">{row.description}</div>}
                            </td>
                            <td className="p-0 m-0">
                              {row.entryType == 'D' ? Number(row.debitAmt).toLocaleString('en-IN',{minimumFractionDigits: 2}) : ''}
                            </td>
                            <td className="p-0 m-0">
                              {row.entryType == 'C' ? Number(row.creditAmt).toLocaleString('en-IN',{minimumFractionDigits: 2}) : ''}
                            </td>
                          </tr>
                            )) */}
                        </React.Fragment>
                      ))}
                      </td>
                      </tr>
                      </tbody>
                    </Table>
                    </Col>
                  </Row>
                  {isLoading && <Row>
                    <Col xs="12">
                      <div className="text-center my-3">
                        <div className="text-success">
                          <i className="bx bx-loader bx-spin font-size-18 align-middle me-2" />
                          Loading...
                        </div>
                      </div>
                    </Col>
                  </Row>}
                  {noMoreData && <Row>
                    <Col xs="12">
                      <div className="text-center my-3">
                        <div className="text-success">
                        -- <i className="fas fa-hourglass-end" /> --
                        </div>
                      </div>
                    </Col>
                  </Row>}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

ProfitReport.propTypes = {
}

export default withRouter(ProfitReport)
